import * as commentService from "./commentCrud";
import { commentSlice, callTypes } from "./commentSlice";

const { actions } = commentSlice;

export const commentGets = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    // https://6200e433fdf5090017249682.mockapi.io/test/1
    // commentService
    //     .gets(request)
    return commentService
        .gets(request)
        .then(response => {
            const { comments, totalRow, pageSize, totalComment } = response.data.data;
            setTimeout(() => {
                dispatch(actions.gets({ totalRow: totalRow, models: comments, pageSize: pageSize, totalComment }));
            }, 200);
        })
        .catch(error => {
            console.log(error);
            //error.clientMessage = "Can't find customers";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const commentGet = request => dispatch => {
    if (request == null || request.id == null || request.id == "") {
        return dispatch(actions.get({ commentAddOrChange: undefined }));
    }
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .get(request)
        .then(response => {
            const model = response.data;
            dispatch(actions.get({ commentAddOrChange: model }));
        })
        .catch(error => {
            //error.clientMessage = "Can't find customer";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const commentRemove = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .remove(request)
        .then(response => {
            dispatch(actions.remove({ id: request.id }));
        })
        .catch(error => {
            //error.clientMessage = "Can't delete customer";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const commentAdd = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .add(request)
        .then(response => {
            setTimeout(() => {
                if (response.data.status === false) {
                    if (response.data?.errorCode && response.data?.errorCode == 3) {
                        window.parent.postMessage({ onMessage: 'too_many_requests', errorName: response.data.messages }, '*');
                    }
                    else if (response.data?.errorCode && response.data?.errorCode == 4) {
                        window.parent.postMessage({ onMessage: 'time_limit', errorName: response.data.messages }, '*');
                    }
                    else {
                        window.parent.postMessage({ onMessage: 'error', errorName: response.data.messages }, '*');
                    }
                } else window.parent.postMessage({ onMessage: 'success' }, '*');
                dispatch(actions.add({ status: true }));
            }, 200);
        })
        .catch(error => {
            // window.parent.postMessage({ onMessage: 'too_many_requests',errorName : ['Bạn không thể gửi bình luận liên tục. Xin hãy đợi 56.658 giây nữa'] }, '*');
            window.parent.postMessage({ onMessage: 'error', errorName: error?.response?.data?.messages }, '*');
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const commentChange = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .change(request)
        .then(() => {
            dispatch(actions.change({ status: true }));
        })
        .catch(error => {
            //error.clientMessage = "Can't update customer";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const commentLike = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .like(request)
        .then(response => {
            // const {customer} = response.data;
            dispatch(actions.add({ status: true }));
        })
        .catch(error => {
            //error.clientMessage = "Can't create customer";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};
export const commentUnLike = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .unlike(request)
        .then(response => {
            // const {customer} = response.data;
            dispatch(actions.add({ status: true }));
        })
        .catch(error => {
            //error.clientMessage = "Can't create customer";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const commentLoadMore = request => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return commentService
        .gets(request)
        .then(response => {
            const { comments } = response.data.data;
            setTimeout(() => {
                dispatch(actions.onLoadMoreComment({ data: comments }));
            }, 200)
        })
        .catch(error => {
            console.log(error);
            //error.clientMessage = "Can't find customers";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};